import React from "react";
import { Edit, Trash2 } from "lucide-react";

export interface TableAction {
  icon: React.ReactNode;
  onClick: (rowIndex: number) => void;
  className?: string;
}

export const createTableActions = (
  onEdit: (rowIndex: number) => void,
  onDelete: (rowIndex: number) => void
): TableAction[] => [
  {
    icon: React.createElement(Edit, { size: 16 }),
    onClick: onEdit,
    className: "text-blue-600 hover:text-blue-900",
  },
  {
    icon: React.createElement(Trash2, { size: 16 }),
    onClick: onDelete,
    className: "text-red-600 hover:text-red-900",
  },
];
